import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { PackageContentEmailRenderer } from "./email";
import type { PackageContentBlockProps } from "./types";

export function PackageContentEditorRenderer(props: PackageContentBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <PackageContentEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
